import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class UserRestServices {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private httpHelper: HttpHelper = inject(HttpHelper);

	signup(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/signup', data, {
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	signupBusiness(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/business/signup', data, {
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	emailAvailable(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/signup/email/available?email=' + params.email + '', {
			params: params,
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	login(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/auth/login', data, {
			withCredentials: true,
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	resetPassword(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/auth/login/recover/password', data, {
			withCredentials: true,
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	recoverPasswordByLink(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/auth/login/reset/password', {
			resetPasswordCode: params.resetPasswordCode,
			password: params.newUserPassword
		}, {
			withCredentials: true,
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	sendPasswordRecoveryMailWithLink(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/auth/login/sendPasswordRecoveryMailWithLink', {
			params: params,
			withCredentials: true,
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	confirmBusinessEmail(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/signup/confirm/business/' + params.email + '/' + params.verificationCode + '', {
			params: {
				language: params.language,
				origin: params.origin
			},
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	confirmEmail(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/signup/confirm/' + params.email + '/' + params.verificationCode + '', {
			params: {
				origin: params.origin
			},
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	requestScreeningRegistration(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/registrations', data, {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	completeScreeningRegistration(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/registrations/' + params.verificationToken + '/complete', data, {
			withCredentials: true,
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createScreeningAccount(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/registrations/'
			+ encodeURIComponent(params.verificationToken || '') + '/complete', {
			password: params.newUserPassword,
			deviceLanguage: params.deviceLanguage
		}, {
			withCredentials: true,
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getScreeningPendingRegistration(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/auth/login/screening/pending-registration?verificationToken='
			+ encodeURIComponent(params.verificationToken || ''), {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	logout(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'publicrest/auth/login', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getSession(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/session', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getSessionId(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/session/id', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	update(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/user/updateUser', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	requestVerificationCode(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/requestVerificationCode', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	validateVerificationCode(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/validateVerificationCode', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	enable2FaAuthentication(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/enable2FaAuthentication', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	generateTotpSecretKey(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/generateTotpSecretKey', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	enableTotpAuthentication(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/enableTotpAuthentication', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	toggleRole(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/user/toggleRole', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	switchToAdminAssistant(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/user/switchToAdminAssistant', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updatePassword(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/user/password/change', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateCoverPicture(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/user/update/picture/COVER_PICTURE/' + params.postId + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateProfilePicture(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/user/update/picture/PROFILE_PICTURE/' + params.postId + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	validateEmail(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/users/email/validate', data, {
			withCredentials: true,
			headers: new HttpHeaders({
		      'Content-Type': 'application/json'
		    })
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	enableChatNotification(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/enableChatNotification', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getChatNotificationStatus(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/getChatNotificationStatus', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	uploadProfileVideo(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/profile/post/user/' + params.id + '/video', data, {
			params: params,
			withCredentials: true,

		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	deleteProfileVideoUploaded(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/profile/post/deleteProfileVideo', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	search(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/users/search/byNameOrEmailSynced', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	uploadCSV(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/worker/import/' + params.name + '', data, {
			params: params,
			withCredentials: true,

		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	uploadDependentsCSV(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/worker/dependent/import/' + params.name + '', data, {
			params: params,
			withCredentials: true,

		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateContactInfo(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/user/contact/info', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getContactInfo(successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/contact/info', {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getConsentsStatus(successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/consent/general/check', {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	acceptConsentUpdates(successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/user/consent/general/accept', {}, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	applyDiscount(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/user/applyDiscount', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	sendBookingFeedback(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/user/rate', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

}
